module.exports = __webpack_public_path__ + "static/actionsquad_540x300-9b31099c78e1cb7c02d1d49b98589deb.png";